import React from 'react';
import { Star, FileText, Zap, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-58" data-mp="eiv6v0fm3gmf">
      {/* Above-the-fold block: fits in one iPhone viewport */}
      <div className="min-h-[100svh] flex flex-col items-center justify-between text-center max-w-5xl mx-auto pt-8 pb-6 md:pt-16 md:pb-12 md:min-h-0" data-id="element-59" data-mp="9ipbb96819z2">
        <div className="text-coral-500 font-bold text-xs sm:text-sm uppercase tracking-[0.2em] mb-4" data-id="element-60" data-mp="129qvjoortvpg">
CLASS ROOM · FUNCIONAL 360
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-stone-900 leading-tight px-2 mb-6" data-id="element-61" data-mp="x8b9btauxj5h">
          Todo tu año de funcional resuelto de una vez.
        </h1>

        <div className="relative mx-auto w-full max-w-[280px] sm:max-w-md md:max-w-3xl flex-shrink min-h-0 flex items-center justify-center mb-6" data-id="element-62" data-mp="nbonp2apio2e">
          <img src="https://cdn.magicpatterns.com/uploads/nTnnY5o5Teogn2a5VKMFdJ/352.png" alt="Megapack Funcional 360 — 12 Tomos y 6 Bonus" className="relative w-full max-h-[40vh] md:max-h-none h-auto object-contain drop-shadow-xl" loading="eager" decoding="async"
        // @ts-ignore — fetchpriority is a valid HTML attr, types lag
        fetchpriority="high" width="800" height="800" data-id="element-63" data-mp="382p6pg8rpjmq" />
        </div>

        <div className="w-full max-w-3xl mx-auto flex flex-col items-center gap-6" data-id="element-64" data-mp="30hhpnn13bczj">
          <h2 className="text-base sm:text-lg md:text-xl text-stone-600 font-medium max-w-2xl" data-id="element-65" data-mp="358rdci32w68s">
            Megapack FUNCIONAL 360 — El sistema completo de planificación y
            clases listas para el profesor de entrenamiento funcional
          </h2>

          <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm font-medium text-stone-700" data-id="element-66" data-mp="2vjg4mwk3t3lf">
            <div className="bg-white px-4 py-2 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-67" data-mp="2lkqzm4db3dml">
              <FileText className="w-4 h-4 mr-2 text-stone-400" data-id="element-68" data-mp="s1rsao8pe6ua" /> PDF
            </div>
            <span className="text-stone-200 hidden sm:inline" data-id="element-69" data-mp="nbbeh30z0j7e">|</span>
            <div className="bg-white px-4 py-2 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-70" data-mp="na0ap37izbga">
              <Zap className="w-4 h-4 mr-2 text-coral-500" data-id="element-71" data-mp="i9vrh5f8g2md" /> Acceso Inmediato
            </div>
          </div>

          <a href="#pricing" className="inline-block bg-coral-500 hover:bg-coral-600 text-white font-bold text-base sm:text-xl py-4 px-8 rounded-2xl transform transition hover:scale-105 shadow-lg shadow-coral-500/20 w-full sm:w-auto text-center" data-id="element-72" data-mp="1b0vvvhhh78ek">
            💪 QUIERO MI FUNCIONAL 360 AHORA
          </a>

          <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm text-stone-600" data-id="element-73" data-mp="x0324yz00hci">
            <div className="bg-white px-3 py-1.5 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-74" data-mp="3lui70k7oini7">
              <Shield className="w-4 h-4 mr-2 text-stone-400" data-id="element-75" data-mp="3htg9c7teujic" /> Garantía 7 días
            </div>
            <span className="text-stone-200 hidden sm:inline" data-id="element-76" data-mp="1x7853o1s1ru4">|</span>
            <div className="bg-white px-3 py-1.5 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-77" data-mp="21bpohm48634d">
              <Lock className="w-4 h-4 mr-2 text-stone-400" data-id="element-78" data-mp="268odxrcy1lw8" /> Pago seguro
            </div>
            <span className="text-stone-200 hidden sm:inline" data-id="element-79" data-mp="2b2ag2plhe7ds">|</span>
            <div className="bg-white px-3 py-1.5 rounded-full shadow-sm flex items-center border border-stone-100" data-id="element-80" data-mp="2g0lr33niinxl">
              <CreditCard className="w-4 h-4 mr-2 text-stone-400" data-id="element-81" data-mp="2kxkivfjpeism" /> Tarjetas y
              transferencia
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function SocialProof() {
  return <div className="bg-stone-50 border-y border-stone-200 py-8 mt-8 md:mt-0" data-id="element-82" data-mp="2txhey28fajxp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center items-center gap-8 md:gap-16 text-center" data-id="element-83" data-mp="uo0t9zww0qp2">
        <div data-id="element-84" data-mp="zndp3a5ql83s">
          <p className="text-2xl font-bold text-stone-900" data-id="element-85" data-mp="4b45noxezwhc">+500</p>
          <p className="text-sm text-stone-500" data-id="element-86" data-mp="4dgy4w0stp8n">profesores confían</p>
        </div>
        <div data-id="element-87" data-mp="3vh5k87gl987q">
          <p className="text-2xl font-bold text-stone-900" data-id="element-88" data-mp="3vjrsk9bazrr0">12+6</p>
          <p className="text-sm text-stone-500" data-id="element-89" data-mp="e8ijrhvv896h">Tomos + Bonus</p>
        </div>
        <div data-id="element-90" data-mp="99xo7vrk6dod">
          <div className="flex justify-center text-coral-500 mb-1" data-id="element-91" data-mp="9big1dmhniij">
            <Star className="w-5 h-5 fill-current" data-id="element-92" data-mp="3hq0tjuv77q9j" />
            <Star className="w-5 h-5 fill-current" data-id="element-93" data-mp="3hqsbi2vvhphc" />
            <Star className="w-5 h-5 fill-current" data-id="element-94" data-mp="3crpkhmcq9jsd" />
            <Star className="w-5 h-5 fill-current" data-id="element-95" data-mp="3ct0ljeesgdfs" />
            <Star className="w-5 h-5 fill-current" data-id="element-96" data-mp="3rgllx0ka3yk0" />
          </div>
          <p className="text-sm text-stone-500" data-id="element-97" data-mp="3rhwpp0dq56b4">4.9/5 calificación ⭐</p>
        </div>
        <div data-id="element-98" data-mp="3mnah14z11ruq">
          <p className="text-2xl font-bold text-stone-900" data-id="element-99" data-mp="2yzsvhr6cvq07">100%</p>
          <p className="text-sm text-stone-500" data-id="element-100" data-mp="2yy7xfrku1oxl">digital · PDF</p>
        </div>
      </div>
    </div>;
}
export function TestimonialsHero() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-101" data-mp="19i5fcl09zci7">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-102" data-mp="19gua0gr6lwoz">
        <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm relative" data-id="element-103" data-mp="1ea5iembn6lj0">
          <div className="text-coral-500 mb-4 flex" data-id="element-104" data-mp="zlsl9m0tiwmx">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-105" data-mp="14kcbvzqcwwlm" data-mpi={i} />)}
          </div>
          <p className="text-stone-700 italic mb-6" data-id="element-106" data-mp="1sa6n6cv12d3r">
            "Organicé todo el mes en una tarde. Nunca más llego a clase sin
            saber qué dar ni cómo progresarlo."
          </p>
          <div className="flex items-center gap-3" data-id="element-107" data-mp="1j98idscrm1k4">
            <div className="w-10 h-10 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold" data-id="element-108" data-mp="1jat9f7zvf2d8">
              JM
            </div>
            <div data-id="element-109" data-mp="7sih8nn77zxd">
              <p className="text-stone-900 font-semibold text-sm" data-id="element-110" data-mp="7s0agx2wu3b7">
                — Javier M.
              </p>
              <p className="text-stone-500 text-xs" data-id="element-111" data-mp="bssm1wz98kan">
                Profesor de Funcional en gimnasio propio
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm relative" data-id="element-112" data-mp="29izftcv5s7o7">
          <div className="text-coral-500 mb-4 flex" data-id="element-113" data-mp="24qg0aacwv2gr">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-114" data-mp="1zrwf4c655upg" data-mpi={i} />)}
          </div>
          <p className="text-stone-700 italic mb-6" data-id="element-115" data-mp="1vrub3wcxop70">
            "Mis alumnos de nivel inicial mejoraron su técnica de sentadilla
            desde la primera semana con el Tomo 2."
          </p>
          <div className="flex items-center gap-3" data-id="element-116" data-mp="1lty0r6rtly9y">
            <div className="w-10 h-10 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold" data-id="element-117" data-mp="1gttjvfn031j7">
              LG
            </div>
            <div data-id="element-118" data-mp="3g6e4o0x590bn">
              <p className="text-stone-900 font-semibold text-sm" data-id="element-119" data-mp="3g4tm79o3t7u5">
                — Laura G.
              </p>
              <p className="text-stone-500 text-xs" data-id="element-120" data-mp="3b607jdx2zase">
                Profesora de Funcional en Gimnasio
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm relative" data-id="element-121" data-mp="3novtdedlclp7">
          <div className="text-coral-500 mb-4 flex" data-id="element-122" data-mp="3sigmas0buphj">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-123" data-mp="19j8mhtkkj14" data-mpi={i} />)}
          </div>
          <p className="text-stone-700 italic mb-6" data-id="element-124" data-mp="30raqgnrn3dy2">
            "Antes tardaba 1 hora armando una clase. Ahora son 5 minutos y la
            progresión está resuelta."
          </p>
          <div className="flex items-center gap-3" data-id="element-125" data-mp="39qe8dof2lnaz">
            <div className="w-10 h-10 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold" data-id="element-126" data-mp="39t0hhshm0avb">
              PR
            </div>
            <div data-id="element-127" data-mp="ozdkox62e3kb">
              <p className="text-stone-900 font-semibold text-sm" data-id="element-128" data-mp="ozx3sh7gaxzx">
                — Pablo R.
              </p>
              <p className="text-stone-500 text-xs" data-id="element-129" data-mp="u1mefvqrh9nh">
                Profesor de Funcional Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}